export const isDev = () => process.env.NODE_ENV !== 'production';

export const warnIfDevBuild = (moduleName) => {
    if (isDev()) {
        console.log(
            `%c Warning: This is a Dev build of ${moduleName}`,
            'background:red; color:white; font-size:18px;'
        );
    }
};

/**
 * helper function that is called after the header has been loaded. useful when you want to have the redux loaded before you start
 * to dispatch actions.
 * @param {func} callback
 */
export const onModuleLoaded = (callback) => {
    const isModuleLoaded = () =>
        window.document.body.getAttribute('data-module-loaded') === 'true';

    try {
        if (isModuleLoaded()) {
            callback();
        }
        const observer = new MutationObserver((mutationsList) => {
            const element = mutationsList.filter(
                (item) => item.attributeName === 'data-module-loaded'
            );
            if (element !== null && isModuleLoaded()) {
                callback();
            }
        });
        observer.observe(window.document.body, { attributes: true });
        // eslint-disable-next-line no-empty
    } catch (error) {}
};
